<div class="profile-dropdown-card">
    <div class="profile-menu-row">
        <div class="profile-media centered-content">
            <ng-container *ngIf="!saving">
                <img *ngIf="previewAvatarUrl && !avatarLoadFailed" [src]="previewAvatarUrl" alt="User avatar"
                    (load)="onAvatarLoaded()" (error)="onAvatarError()" />
                <div *ngIf="!previewAvatarUrl || avatarLoadFailed" class="avatar-fallback centered-content">
                    {{ initial}}
                </div>
            </ng-container>
            <mat-spinner *ngIf="saving" strokeWidth="3" [diameter]="26"></mat-spinner>
        </div>

        <div class="profile-menu-copy">
            <div class="profile-menu-title">{{ profileTitle }}</div>
            <div *ngIf="profileSubtitle" class="profile-menu-subtitle">{{ profileSubtitle }}</div>
        </div>

        <div class="profile-menu-actions flex-row middle">
            <button mat-button color="primary" class="button" (click)="openUploadDialog()" [disabled]="isBusy"
                matTooltip="{{ hasAvatar ? 'Change profile photo' : 'Upload profile photo' }}">
                <mat-icon *ngIf="hasAvatar" svgIcon="edit"> </mat-icon>
                <mat-icon *ngIf="!hasAvatar">file_upload</mat-icon>
            </button>
            <button *ngIf="hasAvatar" mat-button color="primary" class="button remove-button" [disabled]="isBusy"
                (click)="removeAvatar()" matTooltip="Remove profile photo">
                <mat-icon svgIcon="trash"> </mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="canManageCompanyLogo" class="profile-menu-divider"></div>

    <div *ngIf="canManageCompanyLogo" class="profile-menu-row">
        <div class="company-logo-media centered-content">
            <ng-container *ngIf="!logoSaving">
                <img *ngIf="companyLogoUrl && !logoLoadFailed" [src]="companyLogoUrl" alt="Company logo"
                    (load)="onLogoLoaded()" (error)="onLogoError()" />
                <mat-icon *ngIf="!companyLogoUrl || logoLoadFailed">business</mat-icon>
            </ng-container>
            <mat-spinner *ngIf="logoSaving" strokeWidth="3" [diameter]="26"></mat-spinner>
        </div>

        <div class="profile-menu-copy">
            <div class="profile-menu-title">{{ clientName$ | async }}</div>
        </div>

        <div class="profile-menu-actions flex-row middle">
            <button mat-button color="primary" class="button" (click)="openLogoUploadDialog()" [disabled]="isBusy"
                matTooltip="{{ hasCompanyLogo ? 'Change company logo' : 'Upload company logo' }}">
                <mat-icon *ngIf="hasCompanyLogo" svgIcon="edit"> </mat-icon>
                <mat-icon *ngIf="!hasCompanyLogo">file_upload</mat-icon>
            </button>
            <button *ngIf="hasCompanyLogo" mat-button color="primary" class="button remove-button"
                (click)="removeCompanyLogo()" [disabled]="isBusy" matTooltip="Remove company logo">
                <mat-icon svgIcon="trash"> </mat-icon>
            </button>
        </div>
    </div>
</div>